import React, { useState, useMemo } from 'react'
import { View, StyleSheet, LayoutChangeEvent } from 'react-native'
import { Canvas, LinearGradient, Path, BlurMask, vec, Skia } from '@shopify/react-native-skia'

interface AmbientGlowProps {
  colors?: string[]
  positions?: number[]
  opacity?: number
  blurAmount?: number
  strokeWidth?: number
  cornerRadius?: number
}

// Extracted exactly from Figma SVG <stop stop-color="..." />
const FIGMA_COLORS = ['#FAB41C', '#EAA819', '#A9C09D', '#5ABAEE', '#5ABAEE', '#393FFF', '#3BFFD1']

// Extracted exactly from Figma SVG <stop offset="..." />
const FIGMA_POSITIONS = [0.15, 0.223628, 0.297255, 0.45, 0.55, 0.65, 0.8]

export const AmbientGlowBackground = ({
  colors = FIGMA_COLORS,
  positions = FIGMA_POSITIONS,
  opacity = 0.55,
  blurAmount = 60,
  strokeWidth = 40,
  cornerRadius = 16,
}: AmbientGlowProps) => {
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 })
  const { width, height } = dimensions

  const path = useMemo(() => {
    if (width === 0 || height === 0) {
      return Skia.Path.Make()
    }

    const p = Skia.Path.Make()

    p.moveTo(0, height * 0.65)
    p.lineTo(0, height - cornerRadius)
    p.quadTo(0, height, cornerRadius, height)
    p.lineTo(width - cornerRadius, height)
    p.quadTo(width, height, width, height - cornerRadius)
    p.lineTo(width, height * 0.65)

    return p
  }, [width, height, cornerRadius])

  const onLayout = (event: LayoutChangeEvent) => {
    setDimensions({
      width: event.nativeEvent.layout.width,
      height: event.nativeEvent.layout.height,
    })
  }

  return (
    <View style={StyleSheet.absoluteFill} onLayout={onLayout} pointerEvents="none">
      {width > 0 && height > 0 && (
        <Canvas style={StyleSheet.absoluteFill}>
          <Path path={path} style="stroke" strokeWidth={strokeWidth} opacity={opacity}>
            <LinearGradient
              start={vec(width, height)} // x1 in Figma (Right side)
              end={vec(0, height)} // x2 in Figma (Left side)
              colors={colors}
              positions={positions}
            />
            <BlurMask blur={blurAmount} style="normal" />
          </Path>
        </Canvas>
      )}
    </View>
  )
}
